import { Component } from '@angular/core';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss'],
  imports: [TranslatePipe],
})
export class IntroComponent {
  constructor() {}
}
